'use server';
import { actionErrorMessage } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';

export async function deleteSavedMaze(mazeId: string): Promise<ActionResult<void>> {
  try {
    const familyId = await SessionService.getFamilyId();
    if (!familyId) return { success: false, error: 'Not authenticated' };

    const { getSavedMazeRepository } = await import('../repositories');
    const repo = getSavedMazeRepository();

    // Verify ownership
    const maze = await repo.getById(mazeId);
    if (!maze) return { success: false, error: 'Maze not found' };
    if (maze.familyId !== familyId) return { success: false, error: 'Not authorized' };

    // Blob cleanup is best-effort — geometry and source image
    // Blobs are in different containers so we skip cleanup for now
    // (they'll be cleaned up by storage lifecycle policy)

    await repo.delete(mazeId);

    return { success: true, data: undefined };
  } catch (e: unknown) {
    return { success: false, error: actionErrorMessage('deleteSavedMaze', e) };
  }
}
